
import Flag from "../../../assets/duotone/Flag.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FlagIcon({ className, dataTestid = "FlagIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Flag data-testid={dataTestid} className={classes} {...rest} />
  );
}
